import React from 'react';
import { lazy, Suspense } from 'react';
import { Ring, Waveform } from '@uiball/loaders';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomePage from '../HomeChat/HomePage';
import Login from '../LogIn/SignIn';
import SignUp from '../LogIn/SignUp';
import ForgetPassword from '../LogIn/ForgetPassword';
import Profile from '../Profile/Profile';
import Header from '../HeaderUi/Header';
import MainChatFile from '../ChatPdf/MainChatFile';
import OurServices from '../HeaderComponents/OurServices';
import FaqPage from '../HeaderComponents/FaqPage';
import ContactUs from '../HeaderComponents/ContactUs';
import Plans from '../HeaderComponents/Plans';
import ContentCoverage from '../HeaderComponents/ContentCoverage';
import NewHome from '../HomeChat/NewHome';
import PrivacyPolicy from '../HeaderComponents/PrivacyPolicy';
import AboutParasors from '../HeaderComponents/AboutParasors';
import Termsandcondition from '../HeaderComponents/Termsandcondition';
import ViewShareChat from '../ChatPdf/ViewShareChat';
import ViewBlog from '../HomeChat/ViewBlog';
import PrivateRoute from './PrivateRoute';
import ViewNews from '../HomeChat/ViewNews';
import ViewAllArticles from '../HomeChat/ViewAllArticles';
// import ViewAllBlogs from '../HomeChat/ViewAllBlogs';
const ViewAllBlogs = lazy(() => import('../HomeChat/ViewAllBlogs'));
const routesData = createBrowserRouter(
  [
    {
      path: '/',
      element: <NewHome />,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/signup',
      element: <SignUp />,
    },
    {
      path: '/signupstudent',
      element: <SignUp />,
    },
    {
      path: '/forgetpassword',
      element: <ForgetPassword />,
    },
    {
      path: '/profile',
      element: <PrivateRoute element={<Profile />} />,
    },
    {
      path: '/header',
      element: <Header />,
    },
    {
      path: '/services',
      element: <OurServices />,
    },
    {
      path: '/faq',
      element: <FaqPage />,
    },
    {
      path: '/about',
      element: <AboutParasors />,
    },
    {
      path: '/contact',
      element: <ContactUs />,
    },
    {
      path: '/privacypolicy',
      element: <PrivacyPolicy />,
    },
    {
      path: '/termsandcondition',
      element: <Termsandcondition />,
    },
    {
      path: '/plan',
      element: <Plans />,
    },
    {
      path: '/content',
      element: <ContentCoverage />,
    },
    {
      path: '/mainchat/:id',
      element: <PrivateRoute element={<MainChatFile />} />,
    },
    {
      path: '/viewsharechat/:id',
      element: <PrivateRoute element={<ViewShareChat />} />,
    },
    {
      path: '/viewblog',
      element: <ViewBlog />,
    },
    {
      path: '/viewnews',
      element: <ViewNews />,
    },
    {
      path: '/viewallarticles',
      element: <ViewAllArticles />,
    },
    {
      path: '/viewallblogs',
      element: (
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
              }}
            >
              <Ring size={50} lineWeight={5} speed={2} color="#605BFF" />
            </div>
          }
        >
          <ViewAllBlogs />
        </Suspense>
      ),
    },
  ],
  {
    basename: `/`,
  }
);

const MainRouter = ({ children }) => {
  return (
    <React.Fragment>
      <RouterProvider router={routesData}>{children}</RouterProvider>
    </React.Fragment>
  );
};

export default MainRouter;
